export default __webpack_public_path__ + "static/videoPoster-918e2409e2df478a357bf73edf63413d.jpg";